/* eslint-disable @nx/enforce-module-boundaries */
import React from 'react';
import { ABody } from '@marriott/mi-web-ui-kit';
import * as Styled from './MQuickSelectChip.styles';
import type { MQuickSelectChipProps } from './MQuickSelectChip.types';

const COMPONENT_NAME = 'm-mi-chat-components-MQuickSelectChip';
const TEST_ID = 'mi-chat-components-MQuickSelectChip';

export const MQuickSelectChip: React.FC<MQuickSelectChipProps> = ({
  aBody,
  className,
  variant = 'default',
  ...rest
}) => {
  return (
    <Styled.Wrapper
      data-component-name={COMPONENT_NAME}
      data-testid={TEST_ID}
      className={className}
      $variant={variant}
      {...rest}
    >
      <ABody {...aBody} className="pb-0" />
    </Styled.Wrapper>
  );
};

export type { MQuickSelectChipProps };
